import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './VHResultsArea.styled';
import {
  selectAllResults,
  setResultHighlighted,
} from '../../../slices/chat/ChatSlice';
import { useSelector, useDispatch } from 'react-redux';
import ResultItem from '../../molecules/ResultItem/ResultItem';
import NoResultsText from '../../atoms/NoResultsText/NoResultsText';
import { useEffectOnlyOnce } from '../../../utility/EventHooks';

const VHResultsArea = (props) => {
  const results = useSelector(selectAllResults);
  const logsRef = useRef(null);
  const highlightedId = useSelector((state) => state.chat.highlightedResult);
  const dispatch = useDispatch();

  // create refs to enable scrolling to on highlighted change
  // const itemRefs = useRef([]);
  // useEffect(() => {
  //   itemRefs.current = itemRefs.current.slice(0, results.length);
  // }, [results]);

  // // scroll to highlighted id
  // useEffect(() => {
  //   if (highlightedId) {
  //     itemRefs[highlightedId].scrollIntoView();
  //   }
  // }, [highlightedId]);

  // scroll to end when chats are updated
  useEffect(() => {
    if (logsRef && logsRef.current) {
      logsRef.current.scrollTo(0, logsRef.current.scrollHeight);
    }
  }, [results]);

  useEffectOnlyOnce(() => {
    return () => {
      dispatch(setResultHighlighted(null));
    };
  });

  return (
    <Styled.ResultsList ref={logsRef}>
      {results.map((item, index) => (
        <ResultItem
          key={item.idLocal}
          // ref={(el) => (itemRefs.current[item.id] = el)}
          highlighted={item.idLocal === highlightedId}
          resultItem={item}
        />
      ))}
      {results.length === 0 && (
        <NoResultsText>No actions have been performed.</NoResultsText>
      )}
    </Styled.ResultsList>
  );
};

VHResultsArea.propTypes = {};

export default VHResultsArea;
